import './Register.scss';

import { Button, Form, Input, Select, Typography, message } from 'antd';
import {
	UserOutlined,
	FileTextOutlined,
	AlignLeftOutlined,
} from '@ant-design/icons';
import { Controller, useForm } from 'react-hook-form';
import { RegisterForm } from './types';
import { yupResolver } from '@hookform/resolvers/yup';
import validation from './validation';
import { filterOption } from '@/Utils/Utils';
import { ROLES } from '@/constants/common';
import useRegister from '@/Apis/hooks/mutations/useRegister/useRegister';

const Register = () => {
	const { control, handleSubmit, reset } = useForm<RegisterForm>({
		resolver: yupResolver(validation),
	});

	const { mutate: registerUser, isLoading } = useRegister()

	const [messageApi, contextHolder] = message.useMessage();


	const handleRegister = (data: RegisterForm) => {
		registerUser(data, {
			onSuccess: () => {
				messageApi.open({
					type: 'success',
					content: 'Success create a new user',
					duration: 5
				})

				reset()

			},
		})
	};

	return (
		<div className='register-page'>
			{contextHolder}
			<div className='form-container'>
				<div className='form-title'>
					<Typography.Title>Register a new user</Typography.Title>
					<Typography.Text>
						You can create a new user with username and password
					</Typography.Text>
				</div>

				<Form
					className='register-form'
					name='register'
					onFinish={handleSubmit(handleRegister)}
				>
					<Controller
						control={control}
						name='account'
						render={({ field, fieldState: { error } }) => (
							<Form.Item
								validateStatus={error?.message ? 'error' : 'success'}
								help={error?.message}
							>
								<Input
									size='large'
									prefix={<UserOutlined className='site-form-item-icon' />}
									placeholder='Username'
									onChange={field.onChange}
									value={field.value}
								/>
							</Form.Item>
						)}
					/>
					<Controller
						control={control}
						name='nickname'
						render={({ field, fieldState: { error } }) => (
							<Form.Item
								validateStatus={error?.message ? 'error' : 'success'}
								help={error?.message}
							>
								<Input
									size='large'
									prefix={<UserOutlined className='site-form-item-icon' />}
									placeholder='Nickname'
									onChange={field.onChange}
									value={field.value}
								/>
							</Form.Item>
						)}
					/>

					<Controller
						control={control}
						name='roleIds'
						render={({ field, fieldState: { error } }) => (
							<Form.Item
								validateStatus={error?.message ? 'error' : 'success'}
								help={error?.message}
							>
								<Select
									size='large'
									showSearch
									placeholder='Select a Role'
									optionFilterProp='children'
									onChange={field.onChange}
									filterOption={filterOption}
									options={ROLES.map((item) => ({
										value: item.id,
										label: item.label,
									}))}
									value={field.value}
								/>
							</Form.Item>
						)}
					/>

					<Controller
						control={control}
						name='password'
						render={({ field, fieldState: { error } }) => (
							<Form.Item
								validateStatus={error?.message ? 'error' : 'success'}
								help={error?.message}
							>
								<Input
									size='large'
									prefix={<FileTextOutlined className='site-form-item-icon' />}
									type='password'
									placeholder='Password'
									onChange={field.onChange}
									value={field.value}
								/>
							</Form.Item>
						)}
					/>
					<Controller
						control={control}
						name='confirmPassword'
						render={({ field, fieldState: { error } }) => (
							<Form.Item
								validateStatus={error?.message ? 'error' : 'success'}
								help={error?.message}
							>
								<Input
									size='large'
									prefix={<FileTextOutlined className='site-form-item-icon' />}
									type='password'
									placeholder='Confirm Password'
									onChange={field.onChange}
									value={field.value}
								/>
							</Form.Item>
						)}
					/>

					<Controller
						control={control}
						name='remark'
						render={({ field, fieldState: { error } }) => (
							<Form.Item
								validateStatus={error?.message ? 'error' : 'success'}
								help={error?.message}
							>
								<Input
									size='large'
									prefix={<AlignLeftOutlined className='site-form-item-icon' />}
									placeholder='Remark'
									onChange={field.onChange}
									value={field.value}
								/>
							</Form.Item>
						)}
					/>

					<Button
						size='large'
						type='primary'
						htmlType='submit'
						className='login-form-button'
						style={{ width: '100%', marginTop: 12 }}
						loading={isLoading}
					>
						Create a User
					</Button>
				</Form>
			</div>
		</div>
	);
};

export default Register;
